import React, { useEffect, useState } from 'react';
import { TiTick } from 'react-icons/ti';
import editIcon from '../../images/icons/editIcon.svg';
import trash from '../../images/icons/trash.svg';
import AddComponent from './AddComponent';
import getAllPpeComponentMaster from './queries/getAllPpeComponentMaster';
import ApiPagination from '../common/ApiPagination';
import deletePpeComponentMaster from './queries/deletePpeComponentMaster';
import ConfirmDelete from '../Modal/ConfirmDelete';

const ComponentsTable = ({ search, modal, setModal, mode, setMode, policies }) => {
  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [items, setItems] = useState({
    name: '',
    sizable: false,
    isAdhoc: false,
    measurement: null,
    unitPriceUsd: '',
    unitPrice: ''
  });
  useEffect(() => {
    if (search?.length > 2) {
      setpageNumber(1);
    }
  }, [search]);
  const dataone = {
    Page: pageNumber,
    PageSize: rowsCount,
    searchCriteria: search?.length > 2 ? search : '',
    isAll: false
  };

  const { mutate: deletePpeComponent } = deletePpeComponentMaster();
  const { data: ComponentList, isLoading: componentsLoading } = getAllPpeComponentMaster(dataone);
  const columns = ['Component', 'Sizable', 'adhoc', 'Measurement', 'Unit Price(INR)', 'Unit Price(USD)', 'Action'];
  const handleEdit = (item) => {
    setMode('edit');
    setModal(true);
    setItems(item);
  };
  const handleDelete = (item) => {
    setDeleteModal(true);
    setItems(item);
  };
  const confrimDelete = () => {
    deletePpeComponent(items?.id);
    setDeleteModal(false);
    setItems({
      name: '',
      sizable: false,
      isAdhoc: false,
      measurement: null,
      unitPriceUsd: '',
      unitPrice: ''
    });
  };
  const cancelModal = () => {
      setDeleteModal(false);
      setItems({
        name: '',
        sizable: false,
        isAdhoc: false,
        measurement: null,
        unitPriceUsd: '',
        unitPrice: ''
      });
  };

  return (
    <>
      {modal && (
        <AddComponent
          {...{
            modal,
            setModal,
            items,
            setItems,
            mode,
            setMode
          }}
        />
      )}
      {deleteModal && (
        <ConfirmDelete
          modal={deleteModal}
          setModal={setDeleteModal}
          handleDelete={confrimDelete}
          handleCancel={cancelModal}
          message="Delete"
          subMessage="This will permanently delete the component from the Component Mapping screen"
        />
      )}
      <div className="items-table-rebuild-wrap">
        <table className="items-table-rebuild">
          <thead className="z-10">
            <tr>
              {columns.map((item) => (
                <th key={item} className=" capitalize">
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="">
            {componentsLoading && (
              <tr>
                <td colSpan="6">Loading...</td>
              </tr>
            )}
            {ComponentList?.data?.totalItems !== 0 ? (
              <>
                {ComponentList?.data?.items?.map((item) => (
                  <tr key={item?.id} className="">
                    <td title={item?.name}>
                      <label>{item?.name}</label>
                    </td>
                    {/* <img src={checkCircle} alt="CheckCircle" title="Yes" className="w-6" /> */}
                    <td className=" justify-center">
                      <label className="">{item?.sizable && <TiTick size={17} />}</label>
                    </td>
                    <td className=" justify-center">
                      <label className="">{item?.isAdhoc && <TiTick size={17} />}</label>
                    </td>
                    <td title={item?.measurement?.join(', ')}>
                      <label>{item?.measurement?.join(', ')}</label>
                    </td>
                    <td title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}>
                      <label>{Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}</label>
                    </td>
                    <td title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}>
                      <label>{Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}</label>
                    </td>
                    {policies?.ppePolicies?.canEdit && (
                    <td className="ppe-table-action">
                      <button type="button" onClick={() => handleEdit(item)}>
                        <img src={editIcon} alt="EditIcon" title="Edit" className="action-icon w-6" />
                      </button>
                      <button type="button" onClick={() => handleDelete(item)}>
                        <img src={trash} alt="DeleteIcon" title="Delete" className="action-icon w-6" />
                      </button>
                    </td>
                    )}
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {ComponentList?.data?.totalItems > 5 && (
        <ApiPagination
          currentPage={ComponentList?.data?.currentPage}
          totalItems={ComponentList?.data?.totalItems}
          pageSize={ComponentList?.data?.pageSize}
          pageNumber={pageNumber}
          setpageNumber={setpageNumber}
          paginationRowList={[10, 20, 30, 40, 50]}
          rowsCount={rowsCount}
          handleRowsCount={setrowsCount}
          totalPages={ComponentList?.data?.totalPages}
        />
      )}
    </>
  );
};

export default ComponentsTable;
